<template>
  <div class="header">
    <div class="header_logo"><img src="../../assets/logo/weboar_logo_1.png"></div>
    <div id="nav-drawer">
      <input id="nav-input" type="checkbox" class="nav-unshown">
      <label id="nav-open" for="nav-input"><span></span></label>
      <label class="nav-unshown" id="nav-close" for="nav-input"></label>
      <div id="nav-content">
        <div class="w__nav">
          <div class="header_logo"><img src="../../assets/logo/weboar_logo_white.png"></div>
          <hr>
          <div class="link">
            <router-link to="/" class="menu_link">Top</router-link>
            <hr>
            <router-link to="/recruit" class="menu_link">Recruit</router-link>
            <hr>
            <router-link to="/contact" class="menu_link">Contact</router-link>
            <hr>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
$(function(){
    $(".menu_link").on("click", function (evt) {
      chk_status = $("#nav-input").prop("checked");
      if(chk_status){
        $("#nav-input").prop("checked", false);
      }else{
        $("#nav-input").prop("checked", true);
      }
    });
});

$(function() {
  var $win = $(window),
      $main = $('main'),
      $nav = $('div#nav-content'),
      navPos = $nav.offset().top;

  $win.on('load scroll', function() {
    var value = $(this).scrollTop();
    if ( value > navPos ) {
      $('#nav-drawer').css("border-radius", "38px")
      $("#nav-drawer").css("transition", "all 100ms 0s ease");
    } else {
      $('#nav-drawer').css("border-radius", "0")
      $("#nav-drawer").css("transition", "all 100ms 0s ease");

    }
  });
});
</script>


<style>
  .header {
    display: none;
  }

@media screen and (max-width:1024px) {
  .header {
    display: block;
    top: -24px;
  }

  #nav-drawer {
  width: 72px;
  height: 72px;
  position: fixed;
  right: 0;
  background-image: linear-gradient(136deg, #fee140, #fdb960 15%, #fcaa6c 33%, #fa709a);
}

.nav-unshown {
  display:none;
}

/*アイコンのスペース*/
#nav-open {
  display: inline-block;
  width: 24px;
  height: 24px;
  vertical-align: middle;
  padding: 24px;
  padding-top: 27px;
}

  #nav-open:hover {
    cursor: pointer;
  }

/*ハンバーガーアイコンをCSSだけで表現*/
#nav-open span, #nav-open span:before, #nav-open span:after {
  position: absolute;
  height: 2px;/*線の太さ*/
  width: 24px;/*長さ*/
  border-radius: 3px;
  background: #fff;
  display: block;
  content: '';
  cursor: pointer;
  transition: all .4s;
}
#nav-open span:before {
  bottom: -8px;
}
#nav-open span:after {
  bottom: -16px;
}

/*閉じる用の薄黒カバー*/
#nav-close {
  display: none;/*はじめは隠しておく*/
  position: fixed;
  z-index: 99;
  top: 0;/*全体に広がるように*/
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0;
  transition: .3s ease-in-out;
}

/*中身*/
#nav-content {
  overflow: auto;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;/*最前面に*/
  width: 81%;
  max-width: 330px;
  height: 100%;
  background: #DF6D4D;/*背景色*/
  transition: .3s ease-in-out;/*滑らかに表示*/
  -webkit-transform: translateX(-105%);
  transform: translateX(-105%);/*左に隠しておく*/
}

#nav-content .w__nav {
  height: 95%;
  width: 100%;
}

#nav-content .w__nav .header_logo {
  margin: 24px 20px 0px;
  width: 6em;
}

#nav-content .w__nav hr {
  background-color: #fff;
  border-style: none;
  height: 1px;
  width: 90%;
  margin: 0 auto;
  opacity: 0.2;
}

#nav-content .w__nav a:-webkit-any-link {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  text-decoration: none;
}

#nav-content .w__nav .link {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}

#nav-content .w__nav .link a:-webkit-any-link {
  font-size: 14px;
  color: #fff;
  text-decoration: none;
  font-weight: bold;
  padding: 24px 0;
  display: inline-block;
  width: 100%;
}

#nav-content .w__nav .link hr {
  width: 100%;
}

/*チェックが入ったらもろもろ表示*/
#nav-input:checked ~ #nav-close {
  display: block;/*カバーを表示*/
  opacity: .5;
}

#nav-input:checked ~ #nav-content {
  -webkit-transform: translateX(0%);
  transform: translateX(0%);/*中身を表示（右へスライド）*/
  box-shadow: 6px 0 25px rgba(0,0,0,.15);
}

#nav-input:checked ~ #nav-open span {
  -webkit-transform: translateY(20px) rotate(-45deg);
  transform: translateY(10px) rotate(-40deg);
  z-index: 999;
}

#nav-input:checked ~ #nav-open span:before {
  opacity: 0;
}

#nav-input:checked ~ #nav-open span:after {
  -webkit-transform: translateY(-20px) rotate(45deg);
  transform: translateY(-16px) rotate(80deg);
}
  .header {
    display: flex;
    width: 100%;
    height: 3em;
    z-index: 20;
    justify-content: space-between;
    position: relative;
    height: 72px;
    background-color: #fff;
    top:-24px;
  }

  .header .header_logo {
    margin-left: .85714em;
    width: 8em;
    height: 3em;
    padding-top: 24px;
  }

  .header .header_logo img {
    width: 100%;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/common/Header.vue